import { Alert } from '@mui/material';
import type { AlertProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export function ThereWasAnErrorAlert(
    props: Omit<AlertProps, 'children' | 'severity'>,
) {
    return (
        <Alert severity="error" {...props}>
            <FormattedMessage
                defaultMessage="There was an error. Try again after reloading the page or contact <email>{support}</email>"
                values={{
                    support: 'support@binosight.com',
                    email: (chunks) => (
                        <a href={`mailto:${chunks}`}>{chunks}</a>
                    ),
                }}
            />
        </Alert>
    );
}
